export class UserLogin {
  UserName: string;
  Password: string;

  constructor() {
    this.UserName = null;
    this.Password = null;
  }
}